<template>
  <div class="bl-wrapper box_v">
    <div class="bl-title box">
      <div>事件办理</div>
    </div>
    <div class="box box_f1" style="padding: 0 50px;justify-content: space-between">
      <sjbl-left
        :files="files"
        :location="location"
      ></sjbl-left>
      <sjbl-mid
        style="padding-top: 5px"
        :peopleInfo="peopleInfo"
        :shijian="shijian"
      ></sjbl-mid>
      <sjbl-right
        :flow="flow"
        :evaluation="evaluation"
      ></sjbl-right>
    </div>

  </div>
</template>

<script>
  import sjblLeft from './components/sjblLeft'
  import SjblMid from "./components/sjblMid";
  import SjblRight from "./components/sjblRight";
  var that
  export default {
    components: {
      SjblRight,
      SjblMid,
      sjblLeft
    },
    data () {
      return {
        peopleInfo:{
          phone:'',
          name:'',
        },
        shijian:[],
        files:'',
        location:{},
        showMap:false,
        flow:[],
        evaluation:[]
      }
    },
    methods:{
      getEvent () {
        var url = this.urlobj.getShowEvent
        this.$get(url).then(res => {
          if (res.isSucceed) {
            var res = res.rows[0]
            that.getProcess(res.id)
            that.getEvaluation(res.id)
            this.peopleInfo = {
              name:res.userName,
              phone:res.phoneNO.substr(0, 3)+'****'+res.phoneNO.substr(7, 4),
              headPic:res.headPicUrl
            }
            this.shijian = [{
              title:'事件编号',
              info:res.id
            },{
              title:'上报时间',
              info:that.$util.FormatDate(Number(res.createtime), "yyyy-MM-dd")
            },{
              title:'事件详情',
              info:res.content
            },{
              title:'事件地点',
              info:res.address
            }]
            this.files=res.files
            this.location = {
              name:res.address,
              x:JSON.parse(res.location).x,
              y:JSON.parse(res.location).y
            }

          }
        })
      },
      getProcess(id) {
        this.$get(this.urlobj.getProcess,{
          businesskey:id,
        }).then((res) => {
            that.flow = res.rows.map(item => {
              return {
                title:item.taskName,
                time:that.$util.FormatDate(Number(item.respondentTime), "yyyy-MM-dd HH-mm"),
                name:item.exeFullname,
                state:that.handleCheck(item.checkStatus)+that.handleState(item.taskKey),
              }
            })
          console.log(that.flow)
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getEvaluation (id) {
        id='4285325150127104'
        this.$get(this.urlobj.getEvaluation,{
          businesskey:id
        }).then(res => {
          var res = res.rows[0]
          if (res!=null) {
            that.evaluation = [{
              title:'事件评价',
              info:res.createuser+'已评价',
              time:that.$util.FormatDate(Number(res.createtime), "yyyy-MM-dd HH-mm"),
              content:res.labels,
              stars:res.starts
            }]
          }
        })
      },
      handleCheck (check) {
        switch (check) {
          case -1:
            return '正在'
          case 33:
          case 1:
            return '已'
          case 3:
            return '驳回'
        }
      },
      handleState (key) {
        switch (key) {
          case 'task1':
            return '上报'
          case 'task2':
            return'处理'
          case 'task4':
            return '办理'
          case 'task5':
            return '核实'
        }
      }
    },
    mounted () {
      that = this
      this.getEvent()
    }
  }
</script>

<style scoped>
  .bl-wrapper{
    width: 100%;
    height: 100%;
    background-image: url("../../assets/staticsPic/sjbl.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .bl-title{
    height:11.76%;
    font-size: 40px;
    justify-content: center;
    align-items: center;
  }
</style>
